var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicturesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1426 20.5713C35.1426 20.1167 34.962 19.6806 34.6405 19.3591C34.3191 19.0377 33.883 18.857 33.4284 18.857H29.9998L27.4284 15.4285H20.5712L17.9998 18.857H14.5712C14.1166 18.857 13.6805 19.0377 13.359 19.3591C13.0375 19.6806 12.8569 20.1167 12.8569 20.5713V30.857C12.8569 31.3117 13.0375 31.7478 13.359 32.0692C13.6805 32.3906 14.1166 32.5713 14.5712 32.5713H33.4284C33.883 32.5713 34.3191 32.3906 34.6405 32.0692C34.962 31.7478 35.1426 31.3117 35.1426 30.857V20.5713Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 28.7143C26.13 28.7143 27.8569 26.9874 27.8569 24.8571C27.8569 22.7269 26.13 21 23.9997 21C21.8695 21 20.1426 22.7269 20.1426 24.8571C20.1426 26.9874 21.8695 28.7143 23.9997 28.7143Z",
    stroke: "#001184",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicturesIcon);
export default __webpack_public_path__ + "static/media/pictures-icon.9116d8fada8c9c816304c35f5fe65a06.svg";
export { ForwardRef as ReactComponent };